import { useEffect, useState } from "react";
import { useAuthStore } from "@/store/auth";

export function useHasHydrated() {
  const hasHydrated = useAuthStore((s) => s.hasHydrated);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    if (hasHydrated) setHydrated(true);
  }, [hasHydrated]);

  return hydrated;
}
